import { api } from '@/services/api/main/axios';
import { useWorkspace } from '@/composables/useWorkspace';

export const getTrafficSourcesApiRequest = async (
  params: Record<string, unknown> = {},
): Promise<unknown[]> => {
  const res = await api.get<{ payload: unknown[] }>('traffic-sources', { params });
  return res.data.payload;
};

export type GetTrafficSourcesListParams = {
  search?: string;
  status?: string;
  limit?: string | number;
  orderBy?: string;
  orderDirection?: string;
  columns?: string[];
  workspaceId?: string;
};

export const getTrafficSourcesListApiRequest = async (
  params: GetTrafficSourcesListParams,
): Promise<unknown[]> => {
  const { workspaceId, ...rest } = params;
  const workspaceApi = useWorkspace();
  const requestParams: Record<string, unknown> = {
    ...rest,
    workspaceIds: [...new Set([workspaceId, ...workspaceApi.allPublicWorkspacesIds.value])],
  };
  return getTrafficSourcesApiRequest(requestParams);
};

export const getTrafficSourceApiRequest = async (id: string): Promise<Record<string, unknown>> => {
  const res = await api.get<{ payload: Record<string, unknown> }>(`traffic-sources/${id}`);
  return res.data.payload;
};

export const postCreateTrafficSourceApiRequest = async (
  payload: object,
): Promise<Record<string, unknown>> => {
  const res = await api.post<{ payload: Record<string, unknown> }>('traffic-sources', payload);
  return res.data.payload;
};

export const putUpdateTrafficSourceApiRequest = async (
  id: string,
  payload: object,
): Promise<Record<string, unknown>> => {
  const res = await api.put<{ payload: Record<string, unknown> }>(`traffic-sources/${id}`, payload);
  return res.data.payload;
};

export const getTrafficSourceTemplatesApiRequest = async (): Promise<unknown[]> => {
  const res = await api.get<{ payload: unknown[] }>('traffic-sources-templates');
  return res.data.payload;
};

export const getTrafficSourcesCountApiRequest = async (
  params: Record<string, unknown> = {},
): Promise<{ count: number }> => {
  const res = await api.get<{ payload: { count: number } }>('traffic-sources/count', { params });
  return res.data.payload;
};
